import { __rest } from "tslib";
import Icon from 'antd/lib/icon';
import React, { Children } from 'react';
import Tooltip from 'antd/lib/tooltip';
import { connectField, filterDOMProps, joinName } from 'uniforms';
import ListItemField from './ListItemField';
import ListAddField from './ListAddField';

var List = function List(_a) {
  var children = _a.children,
      error = _a.error,
      errorMessage = _a.errorMessage,
      info = _a.info,
      initialCount = _a.initialCount,
      itemProps = _a.itemProps,
      label = _a.label,
      labelCol = _a.labelCol,
      name = _a.name,
      showInlineError = _a.showInlineError,
      value = _a.value,
      wrapperCol = _a.wrapperCol,
      props = __rest(_a, ["children", "error", "errorMessage", "info", "initialCount", "itemProps", "label", "labelCol", "name", "showInlineError", "value", "wrapperCol"]);

  return React.createElement("div", Object.assign({}, filterDOMProps(props)), !!label && React.createElement("div", null, label, !!info && React.createElement("span", null, "\xA0", React.createElement(Tooltip, {
    title: info
  }, React.createElement(Icon, {
    type: "question-circle-o"
  })))), !!(error && showInlineError) && React.createElement("div", null, errorMessage), children ? value.map(function (item, index) {
    return Children.map(children, function (child) {
      return React.cloneElement(child, {
        key: index,
        label: null,
        name: joinName(name, child.props.name && child.props.name.replace('$', index))
      });
    });
  }) : value.map(function (item, index) {
    return React.createElement(ListItemField, Object.assign({
      key: index,
      label: null,
      labelCol: labelCol,
      name: joinName(name, index),
      wrapperCol: wrapperCol
    }, itemProps));
  }), React.createElement(ListAddField, {
    name: "".concat(name, ".$"),
    initialCount: initialCount
  }));
};

List.defaultProps = {
  style: {
    border: '1px solid #DDD',
    borderRadius: '7px',
    marginBottom: '5px',
    marginTop: '5px',
    padding: '10px'
  }
};
export default connectField(List, {
  ensureValue: false,
  includeInChain: false
});